<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('categories')">
            <app-default-button
                    :title="$addLabel('category')"
                    @click="isModalActive = true; selectedUrl = null"
            />
        </app-page-top-section>
        <app-table
                id="category-table"
                :options="options"
                @action="triggerActions"
        />

        <app-category-create-edit
                v-if="isModalActive"
                v-model="isModalActive"
                :selected-url="selectedUrl"
        />

        <app-confirmation-modal
                v-if="confirmationModalActive"
                icon="trash-2"
                modal-id="app-confirmation-modal"
                @confirmed="confirmed('category-table')"
                @cancelled="confirmationModalActive = false"
        />
    </div>
</template>

<script>
    import CategoriesMixins from "../../Mixins/CategoriesMixins";

    export default {
        name: "Categories",
        mixins: [CategoriesMixins],
    }
</script>

<style scoped>

</style>